export default __webpack_public_path__ + "assets/models/f6c181c3f05e805d9738752a2dd24810.glb";